import { useMemo } from 'react'
import HFCard from '../../../components/HFCard'
import { selectChildPractices } from '../../../redux/customer'
import { useAppSelector } from '../../../redux/store'
import { Grid } from '@mui/material'
import ComplianceDonut from '../../../components/ComplianceDonut'
import { Link } from 'react-router-dom'

interface ComplianceDonutData {
  values: {
    compliance: {
      status: number
    }
  }[],
  link: string
  image: string
}

const ComplianceSummary = () => {
  const childPractices = useAppSelector(selectChildPractices)

  const complianceDonutData = useMemo(() => {
    const config = [
      { key: 'Summary', field: 'status', link: '/corp/dashboard', image: 'chart-practices' },
      { key: 'OSHA/HIPAA', field: 'osha_hipaa_compliance_status', link: '/corp/osha-hipaa', image: 'chart-osha-hipaa' },
      { key: 'Training', field: 'training_compliance_status', link: '/corp/training', image: 'chart-training' },
      { key: 'Medications', field: 'kit_compliance_status', link: '/corp/medications', image: 'chart-medication' },
      { key: 'Devices', field: 'device_compliance_status', link: '/corp/devices', image: 'chart-device' },
      { key: 'Biological', field: 'bio_compliance_status', link: '/corp/biological', image: 'chart-biological' },
      { key: 'Waterline Management', field: 'waterline_compliance_status', link: '/corp/waterline-management', image: 'chart-waterline' },
      { key: 'Sharps & Medical Waste', field: 'mwaste_compliance_status', link: '/corp/medical-waste', image: 'chart-mwaste' },
      { key: 'Amalgam Waste', field: 'amalgam_compliance_status', link: '/corp/amalgam-waste', image: 'chart-amalgam-waste' },
    ]

    const data: Record<string, ComplianceDonutData> = Object.fromEntries(
      config.map(({ key, link, image }) => [
        key,
        { values: [], link, image }
      ])
    )

    childPractices.forEach(practice => {
      config.forEach(({ key, field }) => {
        const status = practice[field as keyof typeof practice] as number
        data[key].values.push({ compliance: { status } })
      })
    })

    return data
  }, [childPractices])

  return (
    <HFCard headerText='Compliance Summary'>
      <div className='card-body'>
        <Grid container justifyContent='space-around'>
          {Object.keys(complianceDonutData).map((key) => (
            <Grid item key={key}>
              <Link to={complianceDonutData[key].link}>
                <ComplianceDonut
                  label={key}
                  values={complianceDonutData[key].values}
                  image={complianceDonutData[key].image}
                />
              </Link>
            </Grid>
          ))}
        </Grid>
      </div>
    </HFCard>
  )
}

export default ComplianceSummary